"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

export type FormSectionHeaderProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  trailing?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

export function FormSectionHeader({
  title,
  description,
  trailing,
  className,
  titleClassName,
  descriptionClassName,
}: FormSectionHeaderProps) {
  return (
    <div className={cn("flex items-start justify-between gap-3", className)}>
      <div className="min-w-0 flex-1">
        <h3 className={cn("text-[15px] font-semibold tracking-tight text-foreground", titleClassName)}>
          {title}
        </h3>
        {description ? (
          <p className={cn("mt-1 text-xs leading-relaxed text-muted-foreground", descriptionClassName)}>
            {description}
          </p>
        ) : null}
      </div>
      {trailing ? <div className="shrink-0 pt-0.5">{trailing}</div> : null}
    </div>
  );
}
